import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'
import { IconButton, Badge, Tooltip } from '@mui/material'
import { ClipboardList } from '@styled-icons/heroicons-outline'

import { get } from 'utils/lodash'

import EventBlocker from 'components/common/EventBlocker'
import FilterMenuField from '../common/FilterMenuField'
import RenderFilterOption from './RenderFilterOption'
import { WORK_ORDER_STATUS_FILTER_MENU_OPTIONS } from './settings'
import { isSameAction } from '../utils'

const BUTTON_CLASS_NAME = 'wo-status-filter'

const FiltersMenuButton = ({ sx }) => {
  const { control, watch, setValue } = useFormContext()
  const searchWorkOrderStatusInput = watch('searchWorkOrderStatusInput')
  const selectedWorkOrderStatuses = watch('selectedWorkOrderStatuses')
  const selectedCount = useMemo(() => get(selectedWorkOrderStatuses, 'length', 0), [selectedWorkOrderStatuses])
  const [anchorEl, setAnchorEl] = useState(null)
  const isOpen = Boolean(anchorEl)

  const handleWorkOrderStatusSearchInputChange = (_, value, reason) => {
    if (reason !== 'reset') {
      setValue('searchWorkOrderStatusInput', value)
    }
  }

  const handleClose = event => {
    if (isSameAction(event, BUTTON_CLASS_NAME)) {
      return
    }
    setAnchorEl(null)
  }

  const handleClick = event => {
    event.stopPropagation()
    if (isOpen) {
      handleClose()
      return
    }
    setAnchorEl(event.currentTarget)
  }

  return (
    <EventBlocker>
      <Tooltip title="Work order status" arrow placement="top">
        <IconButton className={BUTTON_CLASS_NAME} sx={sx} onClick={handleClick}>
          <Badge badgeContent={selectedCount} color="primary">
            <ClipboardList size={20} />
          </Badge>
        </IconButton>
      </Tooltip>

      {isOpen && (
        <FilterMenuField
          control={control}
          anchorEl={anchorEl}
          name="selectedWorkOrderStatuses"
          label="Work order status"
          inputValue={searchWorkOrderStatusInput}
          onInputChange={handleWorkOrderStatusSearchInputChange}
          options={WORK_ORDER_STATUS_FILTER_MENU_OPTIONS}
          renderOption={RenderFilterOption}
          onClose={handleClose}
        />
      )}
    </EventBlocker>
  )
}

FiltersMenuButton.propTypes = {
  sx: PropTypes.object,
}

export default FiltersMenuButton
